import React from 'react';
import CancelIcon from "@material-ui/icons/Cancel";
import {AnticipatedDischargePageAction} from "./AnticipatedDischargePage";
import {AnticipatedDischargesFilterValue} from "./domain";
import {formatDate} from 'common/util/date';


type AnticipatedDischargeListFilterBadgeProps = {
    filter: AnticipatedDischargesFilterValue
    dispatch: React.Dispatch<AnticipatedDischargePageAction>
}

export function AnticipatedDischargeListFilterBadge({filter, dispatch}: AnticipatedDischargeListFilterBadgeProps) {
    let values: Array<string> = [];

    if (filter.status) {
        values = values.concat(`Status: ${filter.status}`);
    }

    if (filter.anticipatedDischargeDateFrom) {
        values = values.concat(`Anticipated Discharge Date From: ${formatDate(filter.anticipatedDischargeDateFrom)}`);
    }

    if (filter.anticipatedDischargeDateTo) {
        values = values.concat(`Anticipated Discharge Date To: ${formatDate(filter.anticipatedDischargeDateTo)}`);
    }

    if (filter.dischargeNotificationDateFrom) {
        values = values.concat(`Discharge Notification Due Date From: ${formatDate(filter.dischargeNotificationDateFrom)}`);
    }
    if (filter.dischargeNotificationDateTo) {
        values = values.concat(`Discharge Notification Due Date To: ${formatDate(filter.dischargeNotificationDateTo)}`);
    }


    const updateFilterByRemoveValue = (value: string) => {
        if (value) {
            if (value.includes("Anticipated Discharge Date From: ")) {
                dispatch({type: 'SET_FILTER', filter: {...filter, anticipatedDischargeDateFrom: null}});
                return;
            }
            if (value.includes("Anticipated Discharge Date To: ")) {
                dispatch({type: 'SET_FILTER', filter: {...filter, anticipatedDischargeDateTo: null}});
                return;
            }
            if (value.includes("Discharge Notification Due Date From: ")) {
                dispatch({type: 'SET_FILTER', filter: {...filter, dischargeNotificationDateFrom: null}});
                return;
            }
            if (value.includes("Discharge Notification Due Date To: ")) {
                dispatch({type: 'SET_FILTER', filter: {...filter, dischargeNotificationDateTo: null}});
                return;
            }

            if (value.includes("Status: ")) {
                dispatch({type: 'SET_FILTER', filter: {...filter, status: ''}});
                return;
            }
        }
    }

    if (values.length === 0) {
        return <div/>;
    }

    return (
        <div className='flex pl-5 items-start'>
            <div className='pt-2 pr-5 flex-grow-0'>
                Filter:
            </div>
            <div className='flex flex-grow flex-wrap'>
                {
                    values.map((value) => (
                        <div key={value}
                             className='mr-2 mb-2 bg-botticelli-100 text-white p-2 rounded leading-none flex items-center'>
                            {value}
                            <button className='bg-transparent outline-none focus:outline-none'
                                    onClick={() => updateFilterByRemoveValue(value)}>
                                <div
                                    className='bg-transparent text-white opacity-5 ml-3 outline-none focus:outline-none flex items-center'>
                                    <CancelIcon fontSize={"small"}/>
                                </div>
                            </button>
                        </div>
                    ))
                }
            </div>
        </div>);
}